import { useTranslation } from 'react-i18next';
import GoogleMap from '../components/GoogleMap';
import InstallButton from '../components/InstallButton';

export default function Landing() {
  const { t } = useTranslation();

  // TODO: put the real FB profile/page links here:
  const fbMedard = 'https://www.facebook.com/medard.szilagyinagy';
  const fbGabor  = 'https://www.facebook.com/Sceurpien';
  const campfire = 'https://campfire.nianticlabs.com/#download';

  return (
    <div className="surface-body">
      <h1>{t('landing.title')}</h1>
      <p>{t('landing.tagline')}</p>

      <h2>{t('landing.who')}</h2>
      <p>{t('landing.whoText')}</p>

      <h2>{t('landing.where')}</h2>
      <p>{t('landing.whereText')}</p>

      <p>
        <a href={campfire} target="_blank" rel="noreferrer" style={{ color: '#aee1ff' }}>
          <img src="niantic_campfire_logo.webp" alt="Niantic Campfire" style={{ width: '140px' }} />
        </a>
      </p>

      <h2>{t('landing.whenWhere')}</h2>
      <ul>
        <li>{t('landing.bul1')}</li>
        <li>{t('landing.bul2')}</li>
        <li>{t('landing.bul3')}</li>
      </ul>
      <p>{t('landing.note')}</p>

      <h2 style={{ marginTop: '2rem' }}>{t('landing.mapTitle')}</h2>
      <GoogleMap />

      <h2 style={{ marginTop: '2rem' }}>{t('landing.contacts')}</h2>
      <p>
        <a href={fbMedard} target="_blank" rel="noreferrer" style={{ color: '#aee1ff' }}>
          {t('landing.medard')}
        </a>
      </p>
      <p>
        <a href={fbGabor} target="_blank" rel="noreferrer" style={{ color: '#aee1ff' }}>
          {t('landing.gabor')}
        </a>
      </p>
    </div>
  );
}
